;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _Aside = require("./Aside.vue");

var _Aside2 = _interopRequireDefault(_Aside);

var _Tabs = require("./Tabs.vue");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Cats = require("./Cats.vue");

var _Cats2 = _interopRequireDefault(_Cats);

var _Types = require("./Types.vue");

var _Types2 = _interopRequireDefault(_Types);

var _Select = require("./Select.vue");

var _Select2 = _interopRequireDefault(_Select);

var _Input = require("./Input.vue");

var _Input2 = _interopRequireDefault(_Input);

var _Checkbox = require("./Checkbox.vue");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Autofill = require("./Autofill.vue");

var _Autofill2 = _interopRequireDefault(_Autofill);

var _SizesSelect = require("./SizesSelect.vue");

var _SizesSelect2 = _interopRequireDefault(_SizesSelect);

var _Button = require("./Button.vue");

var _Button2 = _interopRequireDefault(_Button);

var _debounceReduce = require("../utils/debounceReduce");

var _debounceReduce2 = _interopRequireDefault(_debounceReduce);

var _endings = require("../utils/endings");

var _endings2 = _interopRequireDefault(_endings);

var _flatArrays = require("../utils/flatArrays");

var _flatArrays2 = _interopRequireDefault(_flatArrays);

var _data = require("../data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ShinaServiceFilter",
  data: function data() {
    return {
      loading: true,
      updateDependencies: null,
      loadResultsDebounced: null,
      tabs: null,
      user: null,
      results: null,
      location: null
    };
  },
  components: {
    Aside: _Aside2.default,
    Tabs: _Tabs2.default,
    Cats: _Cats2.default,
    Types: _Types2.default,
    Select: _Select2.default,
    Input: _Input2.default,
    Checkbox: _Checkbox2.default,
    Autofill: _Autofill2.default,
    SizesSelect: _SizesSelect2.default,
    Button: _Button2.default
  },
  computed: {
    formattedResults: function formattedResults() {
      var count = Math.floor(this.results);
      return count + " " + (0, _endings2.default)(count, ["вариант", "варианта", "вариантов"]);
    },
    filled: function filled() {
      var _this = this;

      var exclude = ["tab", "cat", "type"];

      return (0, _keys2.default)(this.model).reduce(function (state, key) {
        var value = _this.model[key];
        var inExclude = exclude.includes(key);
        var hasValue = Array.isArray(value) ? Boolean(value.length) : Boolean(value);

        return state || (inExclude ? false : hasValue);
      }, false);
    },
    model: function model() {
      return this.getModel([this.tabs]);
    }
  },
  watch: {
    tabs: {
      deep: true,
      handler: function handler() {
        if (!this.loading) {
          this.saveState();
          this.loadResultsDebounced();
        }
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this2 = this;

      return new _promise2.default(function (resolve) {
        _jquery2.default.getJSON("/selection/api/data").done(function (_ref) {
          var tabs = _ref.tabs,
              user = _ref.user;

          _this2.tabs = tabs;
          _this2.user = user;

          resolve();
        });
      });
    },
    validateStateObject: function validateStateObject(target) {
      if (target === undefined || !target.length) return false;

      return !target.reduce(function (state, item) {
        return state || !("name" in item && "value" in item);
      }, false);
    },
    saveState: function saveState() {
      var _this3 = this;

      return new _promise2.default(function (resolve) {
        var model = (0, _keys2.default)(_this3.model).filter(function (key) {
          return _this3.model[key];
        }).map(function (key) {
          return {
            name: key,
            value: _this3.model[key]
          };
        });

        localStorage.setItem("ShinaServiceFilterState", (0, _stringify2.default)(model));

        resolve();
      });
    },
    restoreState: function restoreState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var localState = localStorage.getItem("ShinaServiceFilterState");
      var _model = this.model,
          tab = _model.tab,
          cat = _model.cat,
          type = _model.type;

      var model = (0, _assign2.default)({}, { tab: tab, cat: cat, type: type }, state);
      var map = (0, _keys2.default)(model).map(function (key) {
        return { name: key, value: model[key] };
      });

      if (localState) {
        try {
          return this.setModel([this.tabs], (0, _flatArrays2.default)(map, JSON.parse(localState)));
        } catch (error) {
          console.error("Error in restoreState method", error);
          return _promise2.default.resolve();
        }
      } else {
        if (map.length) {
          return this.setModel([this.tabs], map);
        }

        return this.saveState();
      }
    },
    getModel: function getModel() {
      var _this4 = this;

      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _create2.default)(null);

      root.forEach(function (item) {
        var value = item.value;
        var current = item.list ? item.list.find(function (node) {
          return node.name === value;
        }) : item;

        if (item.name) {
          if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && value !== null && !Array.isArray(value)) {
            for (var key in value) {
              if (value.hasOwnProperty(key)) {
                model[key] = value[key];
              }
            }
          } else {
            model[item.name] = value;
          }
        }

        if (current && current.childs) {
          _this4.getModel(current.childs, model);
        }
      });

      return model;
    },
    setModel: async function setModel(root, object) {
      var _this5 = this;

      if (!root.length && !this.validateStateObject(object)) {
        return _promise2.default.resolve();
      }

      var _loop = async function _loop(index) {
        var item = root[index];
        var pair = object.find(function (pair) {
          return pair.name === item.name;
        });
        var value = pair ? pair.value : null;

        if ((0, _typeof3.default)(item.value) === "object" && item.value !== null && !Array.isArray(item.value)) {
          var _loop2 = function _loop2(key) {
            if (item.value.hasOwnProperty(key)) {
              var _pair = object.find(function (pair) {
                return pair.name === key;
              });
              item.value[key] = _pair ? _pair.value : item.value[key];
            }
          };

          for (var key in item.value) {
            _loop2(key);
          }
        } else {
          item.value = value || item.value;
        }

        if (item.name) {
          await _this5.updateDependencies(item.name);
        }

        var current = item.list ? item.list.find(function (node) {
          return node.name === value;
        }) : item;

        if (current && current.childs) {
          await _this5.setModel(current.childs, object);
        }
      };

      for (var index = 0; index < root.length; index++) {
        await _loop(index);
      }
    },
    loadSelectOptions: function loadSelectOptions(name) {
      return new _promise2.default(function (resolve) {
        setTimeout(function () {
          resolve([{ label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" }]);
        }, 200);
      });
    },
    loadResults: function loadResults() {
      var _this6 = this;

      _jquery2.default.post("/selection/api/results", this.model).done(function (_ref2) {
        var results = _ref2.results,
            location = _ref2.location;

        _this6.results = results;
        _this6.location = location;
      });
    },
    findDependencies: function findDependencies() {
      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var _this7 = this;

      var name = arguments[1];
      var dependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (!root.length && !name) return null;

      root.forEach(function (item) {
        var value = item.value;
        var current = item.list ? item.list.find(function (node) {
          return node.name === value;
        }) : item;

        if (current && current.deps && current.deps.includes(name)) {
          dependencies.push(current);
        }

        if (current && current.childs) {
          _this7.findDependencies(current.childs, name, dependencies);
        }
      });

      return dependencies;
    },
    debouncedUpdateDependencies: function debouncedUpdateDependencies(root) {
      var _this8 = this;

      return (0, _debounceReduce2.default)(function (dependencies) {
        return dependencies.length ? dependencies.map(async function (dependence) {
          dependence.value = null;

          if (dependence.type === "select") {
            dependence.loading = true;
            dependence.options = await _this8.loadSelectOptions(dependence.name);
            dependence.loading = false;
          }
        }) : [_promise2.default.resolve()];
      }, {
        reducer: function reducer(reduced, name) {
          var dependencies = _this8.findDependencies(root, name);
          var filtredItems = dependencies.filter(function (item) {
            return !reduced.find(function (_ref3) {
              var name = _ref3.name;
              return item.name === name;
            });
          });

          return [].concat((0, _toConsumableArray3.default)(reduced), (0, _toConsumableArray3.default)(filtredItems));
        }
      });
    },
    reset: function reset() {
      var exlude = ["tab", "cat", "type"];
      var handler = function handler(root) {
        var _loop3 = function _loop3(index) {
          var item = root[index];
          var value = item.value;

          if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && value !== null && !Array.isArray(value)) {
            for (var key in value) {
              if (value.hasOwnProperty(key)) {
                item.value[key] = null;
              }
            }
          } else {
            if (!exlude.includes(item.name)) {
              item.value = Array.isArray(item.value) ? [] : null;
            }

            var _current = item.list ? item.list.find(function (node) {
              return node.name === value;
            }) : item;

            if (_current && _current.childs) {
              return {
                v: handler(_current.childs)
              };
            }
          }
        };

        for (var index = 0; index < root.length; index++) {
          var _ret3 = _loop3(index);

          if ((typeof _ret3 === "undefined" ? "undefined" : (0, _typeof3.default)(_ret3)) === "object") return _ret3.v;
        }
      };

      handler([this.tabs]);
    },
    go: function go() {
      if (this.location) {
        this.reset();
        location = this.location;
      }
    },
    onFieldChange: function onFieldChange(_ref4) {
      var name = _ref4.name;

      if (this.updateDependencies) {
        this.updateDependencies(name);
      }
    }
  },
  created: async function created() {
    var _this9 = this;

    await this.loadData();

    this.updateDependencies = this.debouncedUpdateDependencies([this.tabs]);
    this.loadResultsDebounced = (0, _debounceReduce2.default)(this.loadResults.bind(this), {
      delay: 400
    });

    await this.restoreState();

    this.$nextTick(function () {
      _this9.loadResultsDebounced();
      _this9.saveState();
      _this9.loading = false;
    });
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-filter",class:{"is-loading": _vm.loading}},[_c('div',{staticClass:"ss-filter__inner"},[(_vm.loading)?_c('div',{staticClass:"ss-filter__loader"},[_c('Loader')],1):_c('div',{staticClass:"ss-filter__body"},[_c('div',{staticClass:"ss-filter__tabs"},[_c('Tabs',{attrs:{"tabs":_vm.tabs.list},model:{value:(_vm.tabs.value),callback:function ($$v) {_vm.$set(_vm.tabs, "value", $$v)},expression:"tabs.value"}},[_vm._l((_vm.tabs.list),function(tab){return _c('template',{slot:tab.name},[(tab.childs && tab.childs[0].name === "cat")?_c('Cats',{attrs:{"cats":tab.childs[0].list},model:{value:(tab.childs[0].value),callback:function ($$v) {_vm.$set(tab.childs[0], "value", $$v)},expression:"tab.childs[0].value"}},[_vm._l((tab.childs[0].list),function(cat){return _c('template',{slot:cat.name},[(cat.childs && cat.childs[0].name === "type")?_c('Types',{attrs:{"types":cat.childs[0].list},model:{value:(cat.childs[0].value),callback:function ($$v) {_vm.$set(cat.childs[0], "value", $$v)},expression:"cat.childs[0].value"}},[_vm._l((cat.childs[0].list),function(type){return _c('template',{slot:type.name},[(type.childs)?_c('div',{staticClass:"grid is-columns is-filter"},_vm._l((type.childs),function(field){return _c('div',{key:field.name,class:("col-" + (field.col) + (field.loading ? " is-loading" : "") + " col-s-12")},[(field.type === "select")?_c('Select',{attrs:{"options":field.options,"placeholder":field.placeholder,"name":field.name,"multiple":field.multiple,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "input")?_c('Input',{attrs:{"placeholder":field.placeholder,"name":field.name,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "checkbox")?_c('Checkbox',{attrs:{"label":field.label,"name":field.name,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "autofill")?_c('Autofill',{attrs:{"user":_vm.user,"restore-state":_vm.restoreState}}):_vm._e(),(field.type === "sizesSelect")?_c('SizesSelect',{attrs:{"fields":field.fields,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e()],1)}),0):_vm._e()])})],2):_vm._e()],1)})],2):_vm._e(),(tab.childs && tab.childs[0].name === "type")?_c('Types',{attrs:{"types":tab.childs[0].list},model:{value:(tab.childs[0].value),callback:function ($$v) {_vm.$set(tab.childs[0], "value", $$v)},expression:"tab.childs[0].value"}},[_vm._l((tab.childs[0].list),function(type){return _c('template',{slot:type.name},[(type.childs)?_c('div',{staticClass:"grid is-columns is-filter"},_vm._l((type.childs),function(field){return _c('div',{key:field.name,class:("col-" + (field.col) + (field.loading ? " is-loading" : "") + " col-s-12")},[(field.type === "select")?_c('Select',{attrs:{"options":field.options,"placeholder":field.placeholder,"name":field.name,"multiple":field.multiple,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "input")?_c('Input',{attrs:{"placeholder":field.placeholder,"name":field.name,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "checkbox")?_c('Checkbox',{attrs:{"label":field.label,"name":field.name,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e(),(field.type === "autofill")?_c('Autofill',{attrs:{"user":_vm.user,"restore-state":_vm.restoreState}}):_vm._e(),(field.type === "sizesSelect")?_c('SizesSelect',{attrs:{"fields":field.fields,"on-change":_vm.onFieldChange},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}}):_vm._e()],1)}),0):_vm._e()])})],2):_vm._e()],1)})],2)],1),_c('div',{staticClass:"ss-filter__footer"},[(_vm.results !== null)?_c('div',{staticClass:"ss-filter__results"},[(_vm.results > 0)?_c('div',{staticClass:"ss-filter__caption"},[_vm._v("Всего найдено")]):_vm._e(),_c('div',{staticClass:"ss-filter__result"},[_vm._v(_vm._s(_vm.results > 0 ? _vm.formattedResults : 'Ничего не найдено'))])]):_vm._e(),_c('div',{staticClass:"ss-filter__buttons"},[_c('div',{staticClass:"ss-filter__button"},[_c('Button',{attrs:{"label":"Сбросить","styles":[_vm.filled ? "" : "is-disabled"].concat( ["is-bordered", "is-wide", "has-icon", "is-reset"]),"action":_vm.reset}})],1),_c('div',{staticClass:"ss-filter__button"},[_c('Button',{attrs:{"label":"Подобрать","styles":[_vm.filled ? "" : "is-disabled is-green"].concat( ["is-wide", "is-expand"]),"action":_vm.go}})],1)])])]),_c('div',{staticClass:"ss-filter__info"},[_c('Aside')],1)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-265f9738", __vue__options__)
  } else {
    hotAPI.reload("data-v-265f9738", __vue__options__)
  }
})()}